module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Regular.2727e87.woff";